// extracted by mini-css-extract-plugin
export default {"square":"Square_square__5iIai","empty":"Square_empty__2U0il","noLetter":"Square_noLetter__w4OkX","thereLetter":"Square_thereLetter__gsmVt","thisLetter":"Square_thisLetter__yc-FF"};